import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useRouter } from '@cvt/routing';

type SectionKey = 'disciplines' | 'majors' | 'universities';

interface NoAssertionsProps {
    objectKey: SectionKey;
    onSeeList: () => void;
}

export const NoAssertions: React.FC<NoAssertionsProps> = ({
  objectKey,
  onSeeList,
}) => {
  const router = useRouter();
  const objectLabel = objectKey.charAt(0).toUpperCase() + objectKey.slice(1);
  const message = `You haven’t answered any Assertions that would match you to any ${objectLabel}`;

  const handleSeeList = () => {
    onSeeList();
  };

  const handleStartSwiping = () => {
    router.home.go();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: 'calc(100dvh - 168px)' },
      }}>
      <Paper
        elevation={1}
        sx={{ width: '100%', p: 3, textAlign: 'center' }}
      >
        <Stack direction="column" spacing={2} alignItems="center" textAlign="center">
          <Typography variant="h6" gutterBottom>
            {message}
          </Typography>

          <Stack direction="row" spacing={2} justifyContent="center" mt={1}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleSeeList}
              sx={{ borderColor: 'divider', color: 'text.primary', fontSize: 12 }}
            >
                          See {objectLabel}
            </Button>

            <Button variant="contained" color="primary" onClick={handleStartSwiping}>
                          Start Swiping
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

